module.exports = __webpack_public_path__ + "img/hero.59cd9162.webp";